export default __webpack_public_path__ + "static/media/train-rail.82f5b933.png";